import styled, { css, keyframes } from 'styled-components';
import { Link } from 'react-router-dom';

export const RadialContent = styled.div`
  height: 100%;
  display: flex;
  flex-direction: row;

  @media (max-width: 500px) {
    flex-direction: column;
  }
`;

export const UsergroupFilterContent = styled.div`
  height: 100%;
  display: flex;
  flex-direction: row;
`;

const slideIn = keyframes`
  from {
    opacity: 0;
    transform: translateX(-20dvw);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

const slideOut = keyframes`
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(30%);
  }
`;

export const WilkommenText = styled.div<{ $visible: string }>`
  font-family: 'SegoeUIBold';
  font-weight: 700;
  color: ${({ theme }) => (theme.mode === 'dark' ? 'white' : 'black')};
  font-size: 2dvw;

  ${({ $visible }) => {
    if ($visible === 'in') {
      return css`
        animation: ${slideIn} 2s forwards ease;
      `;
    }

    if ($visible === 'out') {
      return css`
        animation: ${slideOut} 1s forwards ease;
      `;
    }

    return '';
  }}

  @media (min-width: 800px) and (max-width: 1200px) {
    font-size: 2dvw;
  }

  @media (min-width: 500px) and (max-width: 800px) {
    font-size: 4dvw;
  }

  @media (max-width: 500px) {
    font-size: 4.5dvw;
  }
`;

export const HeaderWilkommen = styled.div`
  margin-top: 3dvh;
  text-align: center;
  height: 9dvh;
  position: relative;
  overflow: hidden;
`;

export const LinkStyled = styled(Link)`
  display: flex;
  cursor: pointer;
  text-decoration: none !important;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  align-items: center !important;
  font-size: 1rem !important;
`;

export const Cards = styled.div`
  width: 40%;
  height: 85%;
  display: flex;
  align-items: center;
  margin-left: 5%;

  @media (max-width: 500px) {
    height: 40%;
    justify-content: center;
    margin-left: 0;
    width: 100%;
  }

  @media (min-width: 500px) and (max-width: 700px) {
    margin-left: 10%;
    width: 100%;
  }
`;

export const DivRadialMenu = styled.div`
  height: 100%;
  display: flex;
  flex-direction: row;
`;

export const CloseBtn = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  width: 22px;
  height: 22px;
  border: none;
  border-radius: 50%;
  background: #ff5b5b;
  color: #fff;
  font-size: 12px;
  line-height: 1;
  padding: 0;
  cursor: pointer;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;

  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  user-select: none;

  &::before {
    content: '';
    position: absolute;
    inset: -12px; /* expande ~24px no total -> alvo ~46x46 */
    border-radius: 50%;
  }

  &:hover {
    background: #e02424;
  }

  &:focus-visible {
    outline: 2px solid rgba(255, 255, 255, 0.9);
    outline-offset: 2px;
  }
`;
/* 1. estilos */
export const BoxVideoWrapper = styled.div`
  width: 100%;
  height: 100%;
  background: #000;
  border-radius: 6px;
  overflow: hidden;
  position: relative;
  padding-top: 24px;

  box-sizing: border-box;

  @media (max-width: 768px) {
    width: 62%;
    height: 70%;
    background: #000;
    border-radius: 16px;
    overflow: hidden;
    position: relative;
    padding-top: 24px;
    box-sizing: border-box;
    max-width: 100%;
    max-height: 60dvh;
  }
`;

export const DragHandle = styled.div`
  height: 24px;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 12px;
  display: flex;
  align-items: center;
  padding-left: 8px;
  user-select: none;
  cursor: move;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2;
`;
